/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Creations_Monthlytitle1Inputs */

const id_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreasi bulanan`)
};

const ms_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciptaan bulanan`)
};

const da_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlige oprettelser`)
};

const de_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Kreationen`)
};

const en_us2_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly creations`)
};

const es_es2_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creaciones mensuales`)
};

const es_mx2_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creaciones mensuales`)
};

const fil_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buwanang creation`)
};

const fr_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créations mensuelles`)
};

const it_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazioni mensili`)
};

const hu_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havi létrehozások`)
};

const nl_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse creaties`)
};

const no_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlige opprettelser`)
};

const pl_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twory miesięczne`)
};

const pt_br2_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criações mensais`)
};

const pt_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criações mensais`)
};

const ro_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creații lunare`)
};

const fi_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausittaiset luonnit`)
};

const sv_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månatliga skapelser`)
};

const vi_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáng tạo hàng tháng`)
};

const tr_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık oluşturmalar`)
};

const cs_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční vytvoření`)
};

const bg_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечни създавания`)
};

const ru_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячные предложения`)
};

const uk_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісячні створення`)
};

const ar_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنشاءات الشهرية`)
};

const hi_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मासिक निर्माण`)
};

const th_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสร้างรายเดือน`)
};

const ja_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月別作成数`)
};

const zh_cn2_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月创作`)
};

const zh_hant1_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月創作`)
};

const ko_stats_creations_monthlytitle1 = /** @type {(inputs: Stats_Creations_Monthlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월별 생성`)
};

/**
* | output |
* | --- |
* | "Monthly creations" |
*
* @param {Stats_Creations_Monthlytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_creations_monthlytitle1 = /** @type {((inputs?: Stats_Creations_Monthlytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Creations_Monthlytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_creations_monthlytitle1(inputs)
	if (locale === "ms") return ms_stats_creations_monthlytitle1(inputs)
	if (locale === "da") return da_stats_creations_monthlytitle1(inputs)
	if (locale === "de") return de_stats_creations_monthlytitle1(inputs)
	if (locale === "en-US") return en_us2_stats_creations_monthlytitle1(inputs)
	if (locale === "es-ES") return es_es2_stats_creations_monthlytitle1(inputs)
	if (locale === "es-MX") return es_mx2_stats_creations_monthlytitle1(inputs)
	if (locale === "fil") return fil_stats_creations_monthlytitle1(inputs)
	if (locale === "fr") return fr_stats_creations_monthlytitle1(inputs)
	if (locale === "it") return it_stats_creations_monthlytitle1(inputs)
	if (locale === "hu") return hu_stats_creations_monthlytitle1(inputs)
	if (locale === "nl") return nl_stats_creations_monthlytitle1(inputs)
	if (locale === "no") return no_stats_creations_monthlytitle1(inputs)
	if (locale === "pl") return pl_stats_creations_monthlytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_creations_monthlytitle1(inputs)
	if (locale === "pt") return pt_stats_creations_monthlytitle1(inputs)
	if (locale === "ro") return ro_stats_creations_monthlytitle1(inputs)
	if (locale === "fi") return fi_stats_creations_monthlytitle1(inputs)
	if (locale === "sv") return sv_stats_creations_monthlytitle1(inputs)
	if (locale === "vi") return vi_stats_creations_monthlytitle1(inputs)
	if (locale === "tr") return tr_stats_creations_monthlytitle1(inputs)
	if (locale === "cs") return cs_stats_creations_monthlytitle1(inputs)
	if (locale === "bg") return bg_stats_creations_monthlytitle1(inputs)
	if (locale === "ru") return ru_stats_creations_monthlytitle1(inputs)
	if (locale === "uk") return uk_stats_creations_monthlytitle1(inputs)
	if (locale === "ar") return ar_stats_creations_monthlytitle1(inputs)
	if (locale === "hi") return hi_stats_creations_monthlytitle1(inputs)
	if (locale === "th") return th_stats_creations_monthlytitle1(inputs)
	if (locale === "ja") return ja_stats_creations_monthlytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_creations_monthlytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_creations_monthlytitle1(inputs)
	return ko_stats_creations_monthlytitle1(inputs)
});
export { stats_creations_monthlytitle1 as "stats.creations.monthlyTitle" }